<template>
    <div>
        <!-- Modal Cancelar Marcação -->
        <div class="modal fade" :id="modal" tabindex="-1" role="dialog" 
            aria-labelledby="cancelarMarcacaoModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="marcacao">
                    <div class="modal-header">
                        <h5 class="modal-title" id="cancelarMarcacaoModalLabel">Cancelar Atendimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info d-flex justify-content-between" v-if="marcacao.nome_paciente">
                            <div>
                                <div class="lead">{{ marcacao.nome_paciente }}</div>
                                <div>{{ marcacao.procedimento.search }}</div>
                            </div>
                            <div class="text-right">
                                <div v-if="marcacao.id_atendimento">
                                    #{{ marcacao.id_atendimento }}
                                    <div class="small">
                                        {{ $util.getFormatDate(marcacao.dt_inicio) }}
                                    </div>
                                </div>
                                <div v-else-if="marcacao.dt_inicio">
                                    {{ $util.getFormatDate(marcacao.dt_inicio) }}
                                    {{ marcacao.dt_inicio.slice(11,16) }}
                                    <div class="small">
                                        {{ $util.getFormatDate(marcacao.dt_inicio, 'dddd') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="motivos && motivos.length">
                            <div class="col col-12">
                                <az-input
                                    label="Motivo"
                                    type="select"
                                    :optionsList="motivos"
                                    optionsData="id_motivo"
                                    required 
                                    :validate="validate"
                                    v-model="id_motivo" />
                            </div>
                        </div>

                        <az-input type="textarea" rows="3" maxlength="300" label="Motivo de Cancelamento" v-model="motivo" />

                        <!-- Cancelamento de Recorrência -->
                        <div class="mt-3" v-if="marcacao.fl_repetir && !marcacao.id_atendimento">

                            <az-sub-title title="Recorrência" />

                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <input type="radio" value="U" v-model="cancelar_repeticao">
                                    </div>
                                </div>
                                <input type="text" class="form-control" placeholder="Cancelar somente essa marcação" disabled>
                            </div>

                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <input type="radio" value="S" v-model="cancelar_repeticao">
                                    </div>
                                </div>
                                <input type="text" class="form-control" placeholder="Cancelar essa e as seguintes" disabled>
                            </div>

                            <div class="input-group" v-if="1 == 0">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <input type="radio" value="T" v-model="cancelar_repeticao">
                                    </div>
                                </div>
                                <input type="text" class="form-control" placeholder="Cancelar todas as marcações da sequência" disabled>
                            </div>

                        </div>

                        <!-- Outras Marcações do Paciente -->
                        <template v-if="outras && outras.length">
                            <az-sub-title title="Cancelar Também..." class="mt-3" :info_sm="true">
                                <a href="#" @click.prevent="marcar_todas_outras()" class="card-link">
                                    Marcar Todas
                                </a>
                            </az-sub-title>
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(outra, iox) in outras" :key="iox">
                                    <div class="d-flex justify-content-between">
                                        <div class="d-flex">
                                            <input type="checkbox" v-model="outra.id_atendimento" class="mr-3">
                                            <div>
                                                <div>
                                                    {{ outra.procedimento.search }}
                                                    <span class="badge badge-primary ml-2" v-if="outra.outros_proc">
                                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                                        {{ outra.outros_proc }}
                                                    </span>
                                                </div>
                                                <div class="small text-muted">
                                                    {{ outra.medico.search }}
                                                    <span class="badge badge-light ml-2" v-if="outra.unidade_operacao && outra.unidade_operacao.st_sigla">
                                                        {{ outra.unidade_operacao.st_sigla }}
                                                    </span>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="small text-muted text-right">
                                            {{ $util.getFormatDate(outra.dt_inicio) }}
                                            {{ outra.dt_inicio.substr(11,5) }}
                                            <div class="ml-3">
                                                {{ $util.getFormatDate(outra.dt_inicio, 'dddd') }}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </template>

                        <pre v-if="false">{{ outras }}</pre>

                        <!-- Lista de Espera -->
                        <template v-if="lista_espera && lista_espera.length">
                            <az-sub-title class="mt-3" title="Lista de Espera" />
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" 
                                    :class="idx == lista_selecionado ? 'active' : ''" 
                                    v-for="(item, idx) in lista_espera.slice(0,5)" :key="idx"
                                    click="lista_selecionado == idx ? ( lista_selecionado = null ) : ( lista_selecionado = idx )">
                                    <div>
                                        <div>{{ item.nome_paciente }}</div>
                                        <small class="text-muted" v-if="item.medico">{{ item.medico.st_nome_exibicao }}, </small>
                                        <small class="text-muted">{{ item.plano.search }}, </small>
                                        <small class="text-muted">{{ $util.getFormatDate(item.created_at) }}</small>
                                        <small class="text-muted" v-if="item.st_observacoes">{{ item.st_observacoes }}</small>
                                    </div>
                                    <div v-if="item">
                                        <celula-dados-contatos :hor="{ marcacao: item }" />
                                    </div>

                                </button>
                            </div>
                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit color="danger" :disabled="cancelando" @click="confirmar ()">
                            {{ marcacao.id_atendimento ? 'Cancelar Atendimento' : 'Cancelar Marcação' }}
                        </az-submit>

                        <button class="btn btn-danger" type="button" @click="confirmar ()" :disabled="cancelando" v-if="false">
                            <span v-if="cancelando" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                            <span>{{ marcacao.id_atendimento ? 'Cancelar Atendimento' : 'Cancelar Marcação' }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import $ from 'jquery';
import CelulaDadosContatos from "../../shared/table/CelulaDadosContatos.vue";

export default {
    data () { 
        return { 
            motivo: "",
            marcacao: {},
            cancelando: false,
            cancelar_repeticao: "U",
            lista_espera: null, 
            lista_selecionado: null, 
            motivos: null, 
            id_motivo: "", 
            validate: false, 
            outras: null,
        }
    },

    props: ['modalName'],

    components: { 
        AzInput,
        AzSubTitle,
        CelulaDadosContatos,
        AzSubmit
    },

    computed: { 
        modal: function () { 
            return this.modalName ? this.modalName : 'cancelarMarcacaoModal';
        }
    },

    methods: { 
        marcar_todas_outras () { 
            let selec = this.outras.find(item => !item.id_atendimento) ? true : false;

            this.outras.forEach(outra => { 
                outra.id_atendimento = selec;
            });
        },
        
        cancelar (marcacao) { 
            this.marcacao = marcacao;
            this.motivo = "";
            this.cancelando = false;
            this.cancelar_repeticao = "U";
            this.lista_espera = null;
            this.outras = null; 
            $('#' + this.modal).modal('show');

            if ( this.$store.state.user.st_tipo == 'U' ) { 

                /*
                this.$util.load(this, { 
                service: 'marcacoes',
                func: 'show', 
                parms: { 
                    id: id_marcacao,
                    buscar_outras: true, 
                    tempo_remarcacao: 3, 
                },
                loadTo: res => { 
                    if ( res.js_outros_campos && res.js_outros_campos.id_regiao_cd ) { 
                        res.manter_coleta_dom = true;
                    }

                    if ( res.outras && res.outras.length ) { 
                        res.outras = res.outras.filter(item => !item.id_atendimento);
                    }

                    if ( res && outros_parms ) { 
                        this.dados = { 
                            ...res,
                            ...outros_parms,
                        };
                    } else { 
                        this.dados = res;
                    }
                    
                }
            });
                */

                let query = { q: [ 
                    { 
                        name: 'lista_esperas.index',
                        id: 'lista',
                        parms: { 
                            para_cancelar: true, 
                            marcacao: marcacao, 
                        }
                    },
                    { 
                        name: 'motivos.index',
                        id: 'motivos',
                        parms: { 
                            where: { fl_ativo: 1, model_type: 'App\\azure\\atendimentoProcedimento' }, 
                        }
                    },
                    { 
                        name: 'marcacoes.show',
                        id: 'marcacoes',
                        parms: { 
                            id: marcacao.id_marcacao,
                            buscar_outras: true, 
                            tempo_remarcacao: 3, 
                        }
                    }
                ]};

                this.axios.post('/aql', query)
                    .then(res => { 
                        if ( res.data.lista ) { 
                            if ( res.data.lista.status == 200 || res.data.lista.status == 290 ) { 
                                this.lista_espera = res.data.lista.data;
                            }
                        }

                        if ( res.data.motivos.status == 200 || res.data.motivos.status == 290 ) { 
                            this.motivos = res.data.motivos.data;
                        }

                        if ( !marcacao.id_atendimento ) { 
                            if ( res.data.marcacoes.status == 200 || res.data.marcacoes.status == 290 ) { 
                                if ( res.data.marcacoes.data.outras.length ) { 
                                    this.outras = res.data.marcacoes.data.outras.filter(item => !item.id_atendimento);
                                } else if ( res.data.marcacoes.data.outras_cad_temp.length ) { 
                                    this.outras = res.data.marcacoes.data.outras_cad_temp.filter(item => !item.id_atendimento);
                                }
                            }
                        }
                    });

            } else { 

                this.lista_espera = [];
                this.motivos = [];

            }

            /*
            this.$util.loadItem(this, { 
                service: 'lista_esperas',
                func: 'index',
                parms: { 
                    para_cancelar: true, 
                    marcacao: marcacao, 
                }
            })
            .then(res => { 
                this.lista_espera = res;
            });
            */
        },

        confirmar () { 

            this.validate = true;

            let invalids = $('#' + this.modal + ".invalid");

            if (invalids.length && $(".invalid").is(":visible")) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Verificar preenchimento dos campos.",
                    life: 3000
                });

                return;
            }

            this.cancelando = true;
            
            let query = { q: [ 
                { 
                    name: 'agendas.destroy',
                    id: 'cancelar',
                    parms: { 
                        id: this.marcacao.id_marcacao,
                        motivo: this.motivo,
                        id_motivo: this.id_motivo, 
                        cancelar_repeticao: this.cancelar_repeticao, 
                    }
                }
            ]};

            if ( this.outras && this.outras.length ) { 
                this.outras.forEach((outra, idx) => { 
                    if ( outra.id_atendimento ) { 
                        query.q.push({ 
                            name: 'agendas.destroy',
                            id: 'cancelar_outras' + idx,
                            parms: { 
                                id: outra.id_marcacao,
                                motivo: this.motivo,
                                id_motivo: this.id_motivo, 
                                cancelar_repeticao: false, 
                            }
                        });
                    }
                });
            }

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.cancelar.status == 200 || res.data.cancelar.status == 290 ) { 
                        $('#' + this.modal).modal('hide');
                        this.$emit('cancelado');
                    }
                })
                .finally(() => { 
                    this.cancelando = false;
                });
            
        }

    }

}
</script>